<span
  *ngIf="icon || (name && size)"
  class="icon {{ name || icon.name }}-icon"
  [ngClass]="customClass || icon?.customClass"
  [attr.data-size]="size || icon.size | kebabCase"
>
  <svg>
    <use
      attr.xlink:href="{{ locationPath$ | async }}#{{ name || icon.name }}-icon"
    ></use>
  </svg>
</span>
